var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_730_123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 94,
    height: 94,
    rx: 47,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5325 41.322C66.2793 39.0671 67.6035 35.8801 67.1245 32.627C64.2696 32.8254 60.9326 34.6519 58.9855 37.0328C57.2106 39.19 55.7518 42.3991 56.3215 45.5137C59.4425 45.6113 62.6637 43.7406 64.5325 41.322ZM79.9591 71.9232C78.7101 74.7071 78.109 75.9511 76.5 78.4169C74.2555 81.8591 71.0907 86.1452 67.1652 86.1767C63.6811 86.2145 62.7827 83.8935 58.0526 83.9218C53.3226 83.947 52.3366 86.2207 48.8462 86.1861C44.9238 86.1514 41.9249 82.2842 39.6804 78.842C33.4008 69.2243 32.7403 57.9343 36.6126 51.9286C39.3673 47.6646 43.7123 45.1704 47.7943 45.1704C51.9484 45.1704 54.5622 47.463 58.0025 47.463C61.3395 47.463 63.3712 45.1641 68.1763 45.1641C71.8138 45.1641 75.6673 47.1576 78.4096 50.5965C69.4191 55.5534 70.8747 68.4685 79.9591 71.9232Z",
    fill: "#0B0B0A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_730_123",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_730_123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_730_123",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.60621aacf200c24b08567d1bfc2392db.svg";
export { ForwardRef as ReactComponent };